export type MemberTier =
  | 'core'
  | 'returning'
  | 'new'
  | 'occasional'
  | 'lapsed'
  | 'dormant';

export const MEMBER_TIERS: MemberTier[] = [
  'core',
  'returning',
  'new',
  'occasional',
  'lapsed',
  'dormant',
];

/** One space a member belongs to, enough to name it and open it. */
export interface MemberEventRefDto {
  id: string;
  title: string;
  startDate: string | null;
}

/** One account's row on the Members board. Mirrors MemberRow in the functions. */
export interface MemberRowDto {
  uid: string;
  name: string;
  email: string | null;
  role: string;
  company: string;
  basedIn: string | null;
  createdAt: string;
  lastSeen: string;
  isListed: boolean;
  isInternal: boolean;
  isBanned: boolean;
  isFlagged: boolean;
  tier: MemberTier;
  score: number;
  activeDays30: number;
  activeDays90: number;
  pings90: number;
  lastPing: string | null;
  eventsJoined: number;
  eventsJoined90: number;
  posts: number;
  posts90: number;
  likes90: number;
  favoritesGiven: number;
  favoritedBy: number;
  profileViews90: number;
  chatMessages: number;
  chatMessages90: number;
  conversations: number;
  conversationsStarted: number;
  conversationsReplied: number;
  conversationsStarted90: number;
  conversationsReplied90: number;
  lobbyMessages: number;
  lobbyMessages90: number;
  lastChatAt: string | null;
  computedAt: string;
  /** Every space this member is in, newest first. */
  events: MemberEventRefDto[];
  /** When the team last messaged them, and whether they wrote back. */
  contactedAt: string | null;
  contactedBy: string | null;
  contactPreview: string | null;
  contactChatId: string | null;
  repliedToTeam: boolean;
}

export interface MembersBoardDto {
  /** When the snapshot was taken, or null before the first run. */
  computedAt: string | null;
  totals: {
    members: number;
    active30: number;
    regular30: number;
    byTier: Partial<Record<MemberTier, number>>;
  };
  rows: MemberRowDto[];
}

export interface MembersSnapshotResultDto {
  computedAt: string;
  members: number;
  conversations: number;
  senders: number;
  banned: number;
  flagged: number;
}
